"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allSubjectTypes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const events_1 = require("./events");
const issues_1 = require("./issues");
const notifications_1 = require("./notifications");
exports.allSubjectTypes = lodash_1.default.uniq(lodash_1.default.sortBy(events_1.eventSubjectTypes
    .concat(issues_1.issueOrPullRequestSubjectTypes)
    .concat(notifications_1.notificationSubjectTypes)));
//# sourceMappingURL=generic.js.map